import React from 'react';

export const PageHeader = ({ title, description, children }) => (
  <div className="flex items-start justify-between mb-8 pb-6 border-b border-slate-200" data-testid="page-header">
    <div>
      <h1 className="font-heading text-3xl font-semibold text-slate-900 tracking-tight">{title}</h1>
      {description && <p className="text-sm text-slate-500 mt-1">{description}</p>}
    </div>
    {children && <div className="flex items-center gap-2">{children}</div>}
  </div>
);

export const StatusBadge = ({ status, label, className = '' }) => {
  const map = {
    'neu': 'bg-blue-100 text-blue-800',
    'in_bearbeitung': 'bg-amber-100 text-amber-800',
    'dolmetscher_angefragt': 'bg-indigo-100 text-indigo-800',
    'dolmetscher_bestaetigt': 'bg-emerald-100 text-emerald-800',
    'bestaetigt': 'bg-emerald-100 text-emerald-800',
    'meetinglink_versendet': 'bg-cyan-100 text-cyan-800',
    'in_durchfuehrung': 'bg-pink-100 text-pink-800',
    'abgeschlossen': 'bg-slate-100 text-slate-700',
    'storniert': 'bg-red-100 text-red-800',
  };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${map[status] || 'bg-slate-100 text-slate-700'} ${className}`}>
      {label || status}
    </span>
  );
};

export const KpiCard = ({ label, value, icon: Icon, accent = 'text-[#0F4C81]', testid }) => (
  <div className="bg-white border border-slate-200 rounded-md p-5 card-subtle hover:shadow-md transition-shadow" data-testid={testid}>
    <div className="flex items-start justify-between">
      <div>
        <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</div>
        <div className={`mt-2 font-heading text-3xl font-semibold ${accent}`}>{value}</div>
      </div>
      {Icon && <Icon className="w-5 h-5 text-slate-400" />}
    </div>
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="text-center py-16 px-6 bg-white border border-dashed border-slate-300 rounded-md">
    {Icon && <Icon className="w-12 h-12 mx-auto text-slate-300 mb-4" />}
    <h3 className="font-heading text-lg font-medium text-slate-900">{title}</h3>
    {description && <p className="text-sm text-slate-500 mt-1 mb-4">{description}</p>}
    {action}
  </div>
);
